import mapboxGl from "mapbox-gl-latest";
import "mapbox-gl-latest/dist/mapbox-gl.css";

import React, { Component } from "react";
import FlightIcon from "@material-ui/icons/Flight";

import { IconButton } from "@material-ui/core";
import { ClientConfigContext } from "../../../context/clientConfigContext";

mapboxGl.accessToken =
  "pk.eyJ1Ijoic2FpZHVsYmFkaG9uIiwiYSI6ImNsMWR0cW0wNjBlb3UzcXFpbDkycGxibHgifQ.E3gy2p4bShH3EKQYkQVYAg";

class Globe extends Component {
  static contextType = ClientConfigContext;

  constructor(props) {
    super(props);
    this.state = {
      longitude: props.longitude,
      latitude: props.latitude,
      zoom: 15,
    };
  }

  componentDidMount() {
    // useClientConfig cannot be used in the class component
    const config = this.context;

    const map = new mapboxGl.Map({
      container: this.mapContainer,

      style: "mapbox://styles/mapbox/satellite-streets-v11",
      zoom: 2,
      center: [30, 50],

      projection: "globe",
    });

    map.on("style.load", () => {
      map.setFog({}); // Set the default atmosphere style
    });

    // The following values can be changed to control rotation speed:

    // At low zooms, complete a revolution every two minutes.
    const secondsPerRevolution = 120;
    // Above zoom level 5, do not rotate.
    const maxSpinZoom = 5;
    // Rotate at intermediate speeds between zoom levels 3 and 5.
    const slowSpinZoom = 3;

    let userInteracting = false;
    let spinEnabled = true;

    function spinGlobe() {
      const zoom = map.getZoom();
      if (spinEnabled && !userInteracting && zoom < maxSpinZoom) {
        let distancePerSecond = 360 / secondsPerRevolution;
        if (zoom > slowSpinZoom) {
          // Slow spinning at higher zooms
          const zoomDif = (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
          distancePerSecond *= zoomDif;
        }
        const center = map.getCenter();
        center.lng -= distancePerSecond;
        // Smoothly animate the map over one second.
        // When this animation is complete, it calls a 'moveend' event.
        map.easeTo({ center, duration: 1000, easing: (n) => n });
      }
    }

    // Pause spinning on interaction
    map.on("mousedown", () => {
      userInteracting = true;
    });

    // Restart spinning the globe when interaction is complete
    map.on("mouseup", () => {
      userInteracting = false;
      spinGlobe();
    });

    // These events account for cases where the mouse has moved
    // off the map, so 'mouseup' will not be fired.
    map.on("dragend", () => {
      userInteracting = false;
      spinGlobe();
    });
    map.on("pitchend", () => {
      userInteracting = false;
      spinGlobe();
    });
    map.on("rotateend", () => {
      userInteracting = false;
      spinGlobe();
    });

    // When animation is complete, start spinning if there is no ongoing interaction
    map.on("moveend", () => {
      spinGlobe();
    });

    document.getElementById("fly1").addEventListener("click", () => {
      const target = {
        center: config.redPlaneCenter, //[7.679044, 45.0742872], // Red, Reale office in Torino
        zoom: 19,
        bearing: 0,
        pitch: 45,
      };

      map.flyTo({
        ...target, // Fly to the selected target
        duration: 12000, // Animate over 12 seconds
        essential: true, // This animation is considered essential with
        //respect to prefers-reduced-motion
      });
    });

    document.getElementById("fly2").addEventListener("click", () => {
      const target = {
        center: config.greenPlaneCenter, //[14.369258, 37.57785], // Green, a Sicily farmer field
        zoom: 19,
        bearing: 0,
        pitch: 45,
      };

      map.flyTo({
        ...target, // Fly to the selected target
        duration: 12000, // Animate over 12 seconds
        essential: true, // This animation is considered essential with
        //respect to prefers-reduced-motion
      });
    });

    document.getElementById("fly3").addEventListener("click", () => {
      const target = {
        center: [30, 50], // Blue, outer space
        zoom: 2,
        bearing: 0,
        pitch: 0,
      };

      map.flyTo({
        ...target, // Fly to the selected target
        duration: 12000, // Animate over 12 seconds
        essential: true, // This animation is considered essential with
        //respect to prefers-reduced-motion
      });
    });

    spinGlobe();
  }

  render() {
    return (
      <>
        <div
          ref={(el) => (this.mapContainer = el)}
          style={{
            right: 0,
            width: "100%",
            // height: "100%",
            height: "100vh",
          }}
        />
        <IconButton id="fly1" style={{ position: "absolute", zIndex: 1000, top: 20, right: 190 }}>
          <FlightIcon style={{ color: "#ff000040" }} />
        </IconButton>

        <IconButton id="fly2" style={{ position: "absolute", zIndex: 1000, top: 20, right: 150 }}>
          <FlightIcon style={{ color: "#00ff0040" }} />
        </IconButton>

        <IconButton id="fly3" style={{ position: "absolute", zIndex: 1000, top: 60, right: 150 }}>
          <FlightIcon style={{ color: "#0000ff40" }} />
        </IconButton>
      </>
    );
  }
}

export default Globe;
